import { FileSearch } from 'lucide-react';

export function EmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-24">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-muted">
        <FileSearch className="h-10 w-10 text-muted-foreground" />
      </div>
      <h3 className="text-[20px] font-semibold text-[#051923]">
        No AML Client Risk Assessments Yet
      </h3>
    </div>
  );
}
